import React, { useState } from "react";
import "../assets/styles/support.css";

const Support = () => {
  const [type, setType] = useState("bug");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");

  const recipient = type === "bug" ? "edp@cdil.com" : "sales@cdil.com";
  const typeLabel = type === "bug" ? "Bug Report" : "Product Support";

  const handleSubmit = (e) => {
    e.preventDefault();
    const body = `Name: ${name}\nEmail: ${email}\n\n${message}`;
    window.location.href = `mailto:${recipient}?subject=${encodeURIComponent(`[${typeLabel}] ${subject}`)}&body=${encodeURIComponent(body)}`;
  };

  return (
    <div className="support-page">
      <div className="support-container">
        <div className="support-header">
          <h1>Support</h1>
          <p>Get in touch with the right team. We'll get back to you as soon as possible.</p>
          <a href="https://www.cdil.com" className="back-link" target="_blank" rel="noreferrer">
            ← Back to CDIL main website
          </a>
        </div>

        <div className="support-form-card">
          <div className="type-selector">
            <button
              className={type === "bug" ? "type-btn active" : "type-btn"}
              onClick={() => setType("bug")}
              type="button"
            >
              Report a Bug
            </button>
            <button
              className={type === "product" ? "type-btn active" : "type-btn"}
              onClick={() => setType("product")}
              type="button"
            >
              Product Support
            </button>
          </div>

          <p className="recipient-note">
            Your message will be sent to <strong>{recipient}</strong>
          </p>

          <form onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label>Name</label>
                <input
                  type="text"
                  placeholder="Your name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </div>
              <div className="form-group">
                <label>Email</label>
                <input
                  type="email"
                  placeholder="Your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
            </div>

            <div className="form-group">
              <label>Subject</label>
              <input
                type="text"
                placeholder="Brief description"
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
                required
              />
            </div>

            <div className="form-group">
              <label>Message</label>
              <textarea
                placeholder="Describe the issue or enquiry in detail..."
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                rows={6}
                required
              />
            </div>

            <button type="submit" className="submit-btn">
              Open in Email Client
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Support;
